import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { sgrColors } from '../../../../ui/sgr/SgrColors';
import StatisticsSelectionCard from './StatisticsSelectionCard';

const StatisticsSelection = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        height: 'calc(100vh - 12rem)',
        overflowY: 'auto',
        backgroundColor: sgrColors.frost_grey,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2rem',
        padding: '1.5rem',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ textAlign: 'center', maxWidth: '34rem' }}>
        <Typography
          variant="h5"
          component="h1"
          sx={{ fontWeight: 600, color: sgrColors.mine_shaft }}
        >
          {t('statistics_selection.heading')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ marginTop: '0.5rem', color: sgrColors.backdrop }}
        >
          {t('statistics_selection.subtitle')}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 16rem)' },
          gap: '1.5rem',
          width: { xs: '100%', sm: 'auto' },
          maxWidth: '100%',
        }}
      >
        <StatisticsSelectionCard
          title={t('statistics_selection.watchbase_title')}
          description={t('statistics_selection.watchbase_description')}
          iconSrc="/assets/images/hexa_icon.png"
          link="/stats/watchbase"
        />
        <StatisticsSelectionCard
          title={t('statistics_selection.businessbase_title')}
          description={t('statistics_selection.businessbase_description')}
          iconSrc="/assets/images/businessbase_icon.png"
          link="/stats/businessbase"
        />
      </Box>
    </Box>
  );
};

export default StatisticsSelection;
